import React from "react";
import Board from "./Board/Board";
import "../../../assets/scss/crewkanban.scss";
import { KanbanContextProvider } from "./Context/KanbanContext";

const CrewKanban = props =>
    <KanbanContextProvider>
        <Board farmId={props.match.params.farmId} />
    </KanbanContextProvider>;

export default CrewKanban;